<template>
    <div class="header">
        <b @click="goBack()"> ⬅  BACK </b>
        <button class="question" @click="detailVisible = true" v-if="definition">?</button>

        <transition name="fade">
            <div class="definition" v-if="detailVisible">
                <p>{{definition}}</p>
                <button class="close" @click="detailVisible = false">⤫</button>
            </div>
        </transition>
    </div>


</template>

<script>
    export default {
        props: ["definition"],
        data(){
          return {
              detailVisible: false
          }
        },
        methods: {
            showDefinition(){
                this.detailVisible = true;
            },
            goBack(){
                this.$router.go(-1);
            }
        }
    }
</script>